import React from "react";
import useFetch from "../../hooks/useFetch";
import LoadingCard from "../../elements/LoadingCard";
import EspCard from "./EspCard";
import EspErrorCard from "./EspErrorCard";

export default function SuspendedEntities() {
  const { isLoading, data, error } = useFetch("suspended-entities");

  if (isLoading) return <LoadingCard />;

  if (error) {
    return (
      <EspErrorCard error={error}>
        <EspErrorCard.Copy />
      </EspErrorCard>
    );
  }

  return (
    <EspCard data={data} tag={<EspCard.NumberTag />}>
      <EspCard.Section>
        <EspCard.Copy>
          <EspCard.FeaturedDataPoint /> <span>CEs suspended</span>
        </EspCard.Copy>
        <EspCard.Interval />
      </EspCard.Section>
    </EspCard>
  );
}
